import { useContext } from "react"
import { RealtimeContext } from "./RealtimeContext"
import { RealtimeContextType } from "./types"

export const useRealtime = (): RealtimeContextType => {
  const values = useContext(RealtimeContext)
  return values
}
